import { lazy } from 'react';
import { Loadable } from './Loadable';
import { PATH_DASHBOARD } from './paths';

const configuracionesRoutes = [
  {
    component: Loadable(lazy(() => import('../pages/configuracion/Usuarios'))),
    path: PATH_DASHBOARD.configuraciones.usuarios.path,
    shouldRender: PATH_DASHBOARD.configuraciones.usuarios.renderCondition,
  },
];

export default configuracionesRoutes;
